import BaseModel from './BaseModel';
import { PAGINATION } from '../constants/Define';
export default class Baggage extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.id = data.id;
        this.airlineCode = data.airlineCode || undefined;
        this.class = data.class || undefined;
        this.handBaggage = data.handBaggage || undefined;
        this.baggageAllowance = data.baggageAllowance || undefined;
        this.isDomestic = data.isDomestic;
    }

    export() {
        const result = super.export({
            id: this.id,
            airlineCode: this.airlineCode,
            class: this.class,
            handBaggage: this.handBaggage,
            baggageAllowance: this.baggageAllowance,
            isDomestic: this.isDomestic,
        });
        return result;
    }

}